export default __webpack_public_path__ + "static/media/AcceleronsGallery_28.97b48a8d.JPG";